import React from 'react';
import { SimpleModal } from 'components/Modal';
import { CrossButtonBlack } from 'components/Buttons/CrossButton';
import DefaultButton from 'components/Buttons/DefaultButton';
import styles from '../../../dentist/PostJobPage/PostJob.module.scss';

interface AdminAgreementModalProps {
  open: boolean;
  onAgree: () => void;
  onDecline: () => void;
  onClose: () => void;
  dontShowAgain: boolean;
  setDontShowAgain: (val: boolean) => void;
  agreeing?: boolean;
}

const AdminAgreementModal: React.FC<AdminAgreementModalProps> = ({ open, onAgree, onDecline, onClose, dontShowAgain, setDontShowAgain, agreeing }) => {
  return (
    <SimpleModal isOpen={open} onClose={onClose}>
      <div className={styles.popupContainer}>
        <div className={styles.titleContainer}>
          <div className={styles.popupTitle}>View Admin/Reception Shifts</div>
          <CrossButtonBlack className="no-fastclick" onClick={onClose} />
        </div>
        <div className={styles.modalDescription}>
          Admin/Reception shifts are office front-desk roles requiring strong communication, scheduling, patient check-in/check-out, and payment handling. If you agree, you’ll see Admin/Reception shifts alongside Assistant shifts and can submit offers to them.
        </div>
        <ul className={styles.modalDescription} style={{ paddingLeft: 18 }}>
          <li>Answer phone and patient inquiries</li>
          <li>Take payments and manage appointments</li>
          <li>Check-in/check-out patients and coordinate hygiene schedules</li>
          <li>General office support (floater/steri as needed)</li>
        </ul>
        <div className={styles.modalDescription}>
          By tapping Agree, you confirm you understand these roles and consent to view and book Admin/Reception shifts.
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
          <input type="checkbox" checked={dontShowAgain} onChange={(e) => setDontShowAgain(e.target.checked)} />
          Don't show this again
        </label>
        <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
          <DefaultButton variant="contained" color="primary" onClick={onAgree} disabled={!!agreeing}>Agree</DefaultButton>
          <DefaultButton variant="outlined" color="primary" onClick={onDecline} disabled={!!agreeing}>Not now</DefaultButton>
          <DefaultButton onClick={onClose} disabled={!!agreeing}>Close</DefaultButton>
        </div>
      </div>
    </SimpleModal>
  );
};

export default AdminAgreementModal;


